export interface WordItem {
    text: string;
    category: string;
    custom?: boolean;
}

export const CUSTOM_CATEGORY = 'Свои';

export const BASE_WORDS: WordItem[] = [
    // Фильмы и сериалы
    {text: 'Титаник', category: 'Фильмы и сериалы'},
    {text: 'Матрица', category: 'Фильмы и сериалы'},
    {text: 'Гарри Поттер', category: 'Фильмы и сериалы'},
    {text: 'Игра престолов', category: 'Фильмы и сериалы'},
    {text: 'Один дома', category: 'Фильмы и сериалы'},
    {text: 'Терминатор', category: 'Фильмы и сериалы'},
    {text: 'Форрест Гамп', category: 'Фильмы и сериалы'},
    {text: 'Джокер', category: 'Фильмы и сериалы'},
    {text: 'Друзья', category: 'Фильмы и сериалы'},
    {text: 'Во все тяжкие', category: 'Фильмы и сериалы'},
    {text: 'Игра в кальмара', category: 'Фильмы и сериалы'},
    {text: 'Мстители', category: 'Фильмы и сериалы'},
    {text: 'Звёздные войны', category: 'Фильмы и сериалы'},
    {text: 'Пираты Карибского моря', category: 'Фильмы и сериалы'},

    // Животные
    {text: 'Слон', category: 'Животные'},
    {text: 'Жираф', category: 'Животные'},
    {text: 'Пингвин', category: 'Животные'},
    {text: 'Кенгуру', category: 'Животные'},
    {text: 'Крокодил', category: 'Животные'},
    {text: 'Осьминог', category: 'Животные'},
    {text: 'Летучая мышь', category: 'Животные'},
    {text: 'Верблюд', category: 'Животные'},
    {text: 'Панда', category: 'Животные'},
    {text: 'Ёж', category: 'Животные'},
    {text: 'Скунс', category: 'Животные'},
    {text: 'Фламинго', category: 'Животные'},
    {text: 'Хамелеон', category: 'Животные'},
    {text: 'Ленивец', category: 'Животные'},

    // Профессии
    {text: 'Пожарный', category: 'Профессии'},
    {text: 'Хирург', category: 'Профессии'},
    {text: 'Программист', category: 'Профессии'},
    {text: 'Повар', category: 'Профессии'},
    {text: 'Учитель', category: 'Профессии'},
    {text: 'Космонавт', category: 'Профессии'},
    {text: 'Диджей', category: 'Профессии'},
    {text: 'Стоматолог', category: 'Профессии'},
    {text: 'Сантехник', category: 'Профессии'},
    {text: 'Парикмахер', category: 'Профессии'},
    {text: 'Полицейский', category: 'Профессии'},
    {text: 'Фотограф', category: 'Профессии'},
    {text: 'Массажист', category: 'Профессии'},
    {text: 'Электрик', category: 'Профессии'},

    // Действия
    {text: 'Плавать', category: 'Действия'},
    {text: 'Танцевать', category: 'Действия'},
    {text: 'Спать', category: 'Действия'},
    {text: 'Готовить', category: 'Действия'},
    {text: 'Стричься', category: 'Действия'},
    {text: 'Драться', category: 'Действия'},
    {text: 'Прыгать на скакалке', category: 'Действия'},
    {text: 'Играть на гитаре', category: 'Действия'},
    {text: 'Загорать', category: 'Действия'},
    {text: 'Чихать', category: 'Действия'},
    {text: 'Икать', category: 'Действия'},
    {text: 'Кататься на лыжах', category: 'Действия'},
    {text: 'Ловить рыбу', category: 'Действия'},
    {text: 'Красить стену', category: 'Действия'},

    // Предметы
    {text: 'Зонт', category: 'Предметы'},
    {text: 'Будильник', category: 'Предметы'},
    {text: 'Пылесос', category: 'Предметы'},
    {text: 'Микроволновка', category: 'Предметы'},
    {text: 'Наушники', category: 'Предметы'},
    {text: 'Расчёска', category: 'Предметы'},
    {text: 'Зубная щётка', category: 'Предметы'},
    {text: 'Утюг', category: 'Предметы'},
    {text: 'Чайник', category: 'Предметы'},
    {text: 'Фен', category: 'Предметы'},
    {text: 'Штопор', category: 'Предметы'},
    {text: 'Гамак', category: 'Предметы'},
    {text: 'Компас', category: 'Предметы'},
    {text: 'Свеча', category: 'Предметы'},

    // Знаменитости и персонажи
    {text: 'Дарт Вейдер', category: 'Персонажи'},
    {text: 'Человек-паук', category: 'Персонажи'},
    {text: 'Шерлок Холмс', category: 'Персонажи'},
    {text: 'Джеймс Бонд', category: 'Персонажи'},
    {text: 'Бэтмен', category: 'Персонажи'},
    {text: 'Гомер Симпсон', category: 'Персонажи'},
    {text: 'Микки Маус', category: 'Персонажи'},
    {text: 'Волан-де-Морт', category: 'Персонажи'},
    {text: 'Йода', category: 'Персонажи'},
    {text: 'Губка Боб', category: 'Персонажи'},
    {text: 'Чебурашка', category: 'Персонажи'},
    {text: 'Кощей Бессмертный', category: 'Персонажи'},
    {text: 'Баба Яга', category: 'Персонажи'},
    {text: 'Дед Мороз', category: 'Персонажи'},

    // Сказки и мультфильмы
    {text: 'Колобок', category: 'Сказки и мультфильмы'},
    {text: 'Красная Шапочка', category: 'Сказки и мультфильмы'},
    {text: 'Три поросёнка', category: 'Сказки и мультфильмы'},
    {text: 'Золушка', category: 'Сказки и мультфильмы'},
    {text: 'Русалочка', category: 'Сказки и мультфильмы'},
    {text: 'Король Лев', category: 'Сказки и мультфильмы'},
    {text: 'Холодное сердце', category: 'Сказки и мультфильмы'},
    {text: 'Шрек', category: 'Сказки и мультфильмы'},
    {text: 'Мадагаскар', category: 'Сказки и мультфильмы'},
    {text: 'Рапунцель', category: 'Сказки и мультфильмы'},
];
